module.exports = __webpack_public_path__ + "assets/img/role_menpai_name-35f12730.png";